import { cva } from 'class-variance-authority';

export const menuItemTitleVariants = cva('', {
  variants: {
    variant: {
      default: '',
      danger: '',
    },
    disabled: {
      true: 'text-disabled',
      false: '',
    },
  },
  compoundVariants: [
    {
      variant: 'default',
      disabled: false,
      className: 'text-secondary is-platform:text-primary',
    },
    {
      variant: 'danger',
      disabled: false,
      className: 'text-error-primary',
    },
  ],
});

export const menuItemIconVariants = cva('shrink-0', {
  variants: {
    variant: {
      default: '',
      danger: '',
    },
    disabled: {
      true: 'text-disabled',
      false: '',
    },
  },
  compoundVariants: [
    {
      variant: 'default',
      disabled: false,
      className: 'text-quaternary is-platform:text-primary',
    },
    {
      variant: 'danger',
      disabled: false,
      className: 'text-error-primary',
    },
  ],
});

export const menuItemHelpTextVariants = cva('', {
  variants: {
    variant: {
      default: '',
      danger: '',
    },
    disabled: {
      true: 'text-disabled',
      false: '',
    },
  },
  compoundVariants: [
    {
      variant: 'default',
      disabled: false,
      className: 'text-quaternary',
    },
    {
      variant: 'danger',
      disabled: false,
      className: 'text-quaternary',
    },
  ],
});
